import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCopy } from "@fortawesome/free-solid-svg-icons";
import { postRequest, getRequest } from "../../utils/axios";
import { NotificationManager } from "react-notifications";
import { CopyToClipboard } from "react-copy-to-clipboard";

import MainA from "../../layout/Main Admin";
import Input from "../../components/atoms/Input";
import Upload from "../../components/atoms/Upload";
import Button from "../../components/atoms/Button";
import Loader from "../../components/atoms/Loader";
import Modal from "../../components/atoms/Modal";
import Table from "../../components/atoms/Table";
import CustomDropdown from "../../components/atoms/CustomDropdown";

import uploadImage from "../../assets/icons/upload_image.svg";
import plus from "../../assets/icons/plus.svg";

import "./styles.scss";

const Clips = () => {
  const { pageId } = useParams();
  const [clipData, setClipData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [actionLoading, setActionLoading] = useState(false);
  const imageUrl = "https://dynamicproductstorage.blob.core.windows.net/reels";
  const [confirmModalOpen, setConfirmModalOpen] = useState(false);
  const [isAddImageModalOpen, setIsAddImageModalOpen] = useState(false);
  const [eventData, setEventData] = useState([]);
  const [playUrl, setPlayUrl] = useState("");
  const [isPlayModalOpen, setIsPlayModalOpen] = useState(false);
  const [selectedFilterEvent, setSelectedFilterEvent] = useState({
    label: "All Events",
    value: null,
  });
  const [confirmModalData, setConfirmModalData] = useState({
    galleryFileTitle: "",
    fileName: "",
  });

  const emptyData = {
    galleryFileTitle: "",
    fileName: "",
  };

  const [galleryFileTitle, setGalleryFileTitle] = useState("");
  const [imageFile, setImageFile] = useState("");
  const [resetFile, setResetFile] = useState(0);
  const [selectedEvent, setSelectedEvent] = useState({});

  useEffect(() => {
    getClips();
  }, []);

  const getClips = async () => {
    setLoading(true);
    try {
      const resp = await getRequest("EventClip/GetEventClip");
      const data = resp.data || [];
      getEvents();
      setClipData(data);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      NotificationManager.error("Failed to fetch clip data");
    }
  };

  const handleTableCheckboxChange = (e, rowdata) => {
    e.preventDefault();
    setConfirmModalOpen(true);
    setConfirmModalData(rowdata);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("file", imageFile);
    formData.append("EventClipTitle", galleryFileTitle);
    formData.append("PageId", selectedEvent?.value);

    try {
      setActionLoading(true);

      const resp = await postRequest(`EventClip/PostEventClip`, formData);

      if (resp.status === 200) {
        NotificationManager.success("Clip uploaded successfully");
        getClips();
        setGalleryFileTitle("");
        setImageFile("");
        setResetFile(resetFile + 1);
        setIsAddImageModalOpen(false);
      } else {
        NotificationManager.error("Upload failed");
      }
    } catch (error) {
      NotificationManager.error("Network error occurred");
    } finally {
      setActionLoading(false);
    }
  };

  const removeClip = async (eventClipId) => {
    setActionLoading(true);
    try {
      const resp = await getRequest(`EventClip/Delete/${eventClipId}`);
      if (resp.status === 200) {
        NotificationManager.success("Clip removed successfully");
        getClips();
      }
    } catch (error) {
      NotificationManager.error("Failed to remove clip");
    } finally {
      setActionLoading(false);
    }
  };

  const handleCloseConfirmationModal = () => {
    setConfirmModalData(emptyData);
    setConfirmModalOpen(false);
  };

  const handleConfirmModalYes = async () => {
    await removeClip(confirmModalData.eventClipId);
    setConfirmModalOpen(false);
  };

  const handleUpload = (file) => {
    setImageFile(file);
    const fileName = file.name;
    if (galleryFileTitle === "") {
      setGalleryFileTitle(fileName);
    }
  };

  const handleGalleryFileTitleChange = (e) => {
    setGalleryFileTitle(e.target.value);
  };

  const handleAddImage = () => {
    setIsAddImageModalOpen(true);
  };

  const getEvents = async () => {
    try {
      const resp = await getRequest(`Page/GetPagesByCategoryType/26`);
      setEventData(resp.data);
      if (pageId) {
        const event = resp.data.find((e) => e.pageId == pageId);
        setSelectedFilterEvent(
          event
            ? { label: event.pageName, value: event.pageId }
            : { label: "All Events", value: null }
        );
      } else {
        setSelectedFilterEvent({ label: "All Events", value: null });
      }
    } catch (error) {
      console.error("Error fetching events:", error);
    }
  };

  return (
    <MainA className="b-clip-list">
      {loading && <Loader loading={loading} />}
      <Modal
        isOpen={confirmModalOpen}
        closeModal={handleCloseConfirmationModal}
      >
        <div className="delete-modal">
          <div className="circle">!</div>
          <h4>Are you sure you want to remove the clip?</h4>
          <div className="v-modal-button-wrapper">
            <Button onClick={handleConfirmModalYes}>Yes, Remove clip</Button>
            <Button onClick={handleCloseConfirmationModal} type="primary">
              Cancel
            </Button>
          </div>
        </div>
      </Modal>
      <Modal
        isOpen={isAddImageModalOpen}
        closeModal={() => setIsAddImageModalOpen(false)}
      >
        <div className="gallery-add-image">
          <img src={uploadImage} alt="" />
          <form onSubmit={handleSubmit}>
            <div className="upload-image-form">
              <div className="enter-name">
                <label htmlFor="event-dropdown">Select Event:</label>
                <CustomDropdown
                  className="custom-dropdown-variant"
                  value={selectedEvent}
                  onSelect={(option) => setSelectedEvent(option)}
                  options={eventData.map((wnd) => ({
                    label: wnd.pageName,
                    value: wnd.pageId,
                  }))}
                  placeholder="-Select-"
                />
              </div>

              <div className="enter-name">
                <label htmlFor="galleryFileTitle">Clip Name:</label>
                <Input
                  id="galleryFileTitle"
                  type="text"
                  value={galleryFileTitle}
                  onChange={handleGalleryFileTitleChange}
                  required
                />
              </div>
              <div className="adjust-width">
                <label htmlFor="image">Upload Clip:</label>
                <Upload
                  onChange={handleUpload}
                  allowedFiles={["mp4", "mov", "avi", "mkv", "webm"]}
                  resetFile={resetFile}
                />
              </div>

              <Button
                className="gallery-btn"
                type="submit"
                disabled={actionLoading}
              >
                Submit
              </Button>
            </div>
          </form>
        </div>
      </Modal>

      <Modal
        isOpen={isPlayModalOpen}
        closeModal={() => setIsPlayModalOpen(false)}
      >
        <div className="play-video-modal">
          <video
            src={playUrl}
            controls
            autoPlay
            style={{ width: "100%", borderRadius: "10px" }}
          />
        </div>
      </Modal>

      <div className="gallery-wrapper">
        <div className="heading-wrapper">
          <div className="upper-section">
            <Button onClick={handleAddImage} className="add-image-btn">
              <img src={plus} alt="add icon" /> Add Clip
            </Button>
            <CustomDropdown
              className="custom-dropdown-variant"
              value={selectedFilterEvent}
              onSelect={(option) => setSelectedFilterEvent(option)}
              options={[
                { label: "All Events", value: null },
                ...eventData.map((wnd) => ({
                  label: wnd.pageName,
                  value: wnd.pageId,
                })),
              ]}
              placeholder="Filter by Event"
            />
          </div>
          {clipData.length > 0 ? (
            <div className="lower-section">
              <div className="upload-and-detail">
                <Table>
                  <thead>
                    <tr>
                      <th>Clip Title </th>
                      <th>Event</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {clipData.filter((wnd) =>
                        selectedFilterEvent?.value ? wnd.pageId === selectedFilterEvent.value : true
                      ).map((wnd) => (
                        <tr key={wnd.eventClipId}>
                          <td>
                            {wnd.eventClipTitle}
                          </td>
                          <td>{eventData.find((e) => e.pageId === wnd.pageId)?.pageName || ""}</td>
                          <td className="file-path-cell truncate">
                            <CopyToClipboard
                              className="copy-btn"
                              text={`${imageUrl}/${wnd.eventClipFilePath.replace(
                                /\\/g,
                                "/"
                              )}${wnd.eventClipFileName}`}
                              onCopy={() => {
                                NotificationManager.success(
                                  "Copied to clipboard!"
                                );
                              }}
                            >
                              <FontAwesomeIcon icon={faCopy} />
                            </CopyToClipboard>
                            <Button
                              className="gallery-btn" 
                              onClick={() => {
                                const url = `${imageUrl}/${wnd.eventClipFilePath.replace(/\\/g, "/")}${wnd.eventClipFileName}`;
                                setPlayUrl(url);
                                setIsPlayModalOpen(true);
                              }}
                            >
                              Play
                            </Button>
                            <Button
                              className="gallery-btn"
                              onClick={(e) => handleTableCheckboxChange(e, wnd)}
                              disabled={actionLoading}
                            >
                              Delete
                            </Button>
                          </td>
                        </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            </div>
          ) : null}
        </div>
      </div>
    </MainA>
  );
};

export default Clips;
